<template>
  <div>
    <div
      v-if="mode !== workspace.OWNER"
    >
      <!-- LeaveTeam: member of team -->
      <aha-modal
        :title="getModalTitle()"
        @hide="hideMemberModal()"
      >
        <div class="tab-content pb-4" v-if="isTeamCreatedByAdmin">
          <p>
            {{ $i18nPresenter.t("By leaving the team, you will no longer have access to the team's plan.") }}
          </p>
        </div>
        <div class="tab-content pb-4" v-else>
          <p>
            {{ $i18nPresenter.t("Leaving the team means losing access to its presentations.") }}
          </p>
        </div>
        <template #action>
          <aha-button variant="danger" class="mr-4" @click="leaveTeam(1)">
            {{ $i18nPresenter.t("Leave") }}
            <aha-spinner
              variant="white"
              class="ml-2"
              v-if="leaveTeamLoadingShow"
            />
          </aha-button>
          <aha-link
            @click="hideMemberModal"
          >
            <span class="font-bold">{{ $i18nPresenter.t("Cancel") }}</span>
          </aha-link>
        </template>
      </aha-modal>
    </div>
    <div v-else>
      <!-- LeaveTeam: Admin or Owner, leaving also remove member of that team and delete team -->
      <aha-modal
        :title="getModalTitle()"
        @hide="hideAdminModal()"
      >
        <div class="tab-content pb-4">
          <p>
            {{ $i18nPresenter.t("By leaving the team as an owner, the members will no longer belong to this team.") }}
          </p>
        </div>
        <template #action>
          <aha-button variant="danger" class="mr-4" @click="leaveTeam(2)">
            {{ $i18nPresenter.t("Leave and delete team") }}
            <aha-spinner
              class="ml-2"
              variant="white"
              v-if="leaveTeamLoadingShow"
            />
          </aha-button>
          <aha-link
            @click="hideAdminModal"
          >
            <span class="font-bold">{{ $i18nPresenter.t("Cancel") }}</span>
          </aha-link>
        </template>
      </aha-modal>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import AccountApi from '@/api/account'
import Util from '@/util'
import eventCategories from '@/constant/eventCategories'
import constants from '@/constant'

export default {
  props: {
    mode: {
      type: String,
      default: 'member',
    },
    teamName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      leaveTeamLoadingShow: false,
      workspace: constants.workspace,
    }
  },
  computed: {
    isTeamCreatedByAdmin() {
      if (this.$store.state.currentAccount.createdFrom === 'presenter') return false
      return true
    },
  },
  methods: {
    ...mapActions([
      'setCurrentAccountAction',
      'setCurrentUserAction',
    ]),
    hideAdminModal() {
      this.$emit('hide')
      const eventLabel = this.$store.state.currentUser.email
      Util.mixpanelTracking(
        eventCategories.MY_TEAM,
        'Team Management > Leave team > Canceled',
        eventLabel,
        '',
        {
          plan: this.$store.state.currentUser.plan,
          isAdmin: true,
        },
      )
    },
    hideMemberModal() {
      this.$emit('hide')
      const eventLabel = this.$store.state.currentUser.email
      Util.mixpanelTracking(
        eventCategories.MY_TEAM,
        'Team Management > Leave team > Canceled',
        eventLabel,
        '',
        {
          plan: this.$store.state.currentUser.plan,
          isAdmin: false,
        },
      )
    },
    getModalTitle() {
      let name = this.teamName
      if (this.teamName.length > 50) {
        name = `${name.slice(0, 50)}...`
      }
      return this.$i18nPresenter.t('Are you sure you want to leave the team “{teamName}”?', { teamName: name })
    },
    async leaveTeam(mode) {
      try {
        this.leaveTeamLoadingShow = true
        const leave = await AccountApi.leaveTeam()
        const { status } = leave
        if (status === 200) {
          this.leaveTeamLoadingShow = false
          this.setCurrentAccountAction(null)
          const user = this.$store.state.currentUser
          this.setCurrentUserAction({
            ...user,
            accountId: null,
            accountRole: null,
          })
          this.$emit('hide')
          if (mode === 1) Util.showToastSuccess(this.$i18nPresenter.t('Successfully left the team.'))
          if (mode === 2) Util.showToastSuccess(this.$i18nPresenter.t('Successfully left and deleted the team.'))
          this.$router.push({ name: 'Presentations' })
        }
        const eventLabel = this.$store.state.currentUser.email
        Util.mixpanelTracking(
          eventCategories.MY_TEAM,
          'Team Management > Leave team > Confirmed',
          eventLabel,
          '',
          {
            plan: this.$store.state.currentUser.plan,
            isAdmin: false,
          },
        )
      } catch (error) {
        Sentry.captureException(error)
        if (error.status === 0) Util.showToastError(this.$i18nPresenter.t('Something went wrong, please check your connection or contact us for support'))
        else Util.showToastError(error.body.message)
      }
    },
  },
}
</script>
<style scoped lang="scss">
.tab-content {
  .ul {
    list-style: disc !important;
    padding-left: 1.25rem !important;
  }
}
</style>
